<template>
  <Container>
    <div class="ding-toolbar">
      <div class="ding-toolbar-left">
        <Input
          search
          clearable
          style="width:220px;"
          v-model="filter.search"
          placeholder="搜索姓名 / userid / 工号 / 部门"
        />
        <Input
          clearable
          style="width:160px;"
          v-model="filter.deptId"
          placeholder="部门 ID（可选）"
          @on-enter="loadData"
        />
        <Button @click="loadData" :loading="loading">查询</Button>
      </div>
      <div class="ding-toolbar-right">
        <span class="ding-muted">共 {{ filteredData.length }} / {{ items.length }} 人</span>
        <Button icon="md-refresh" :loading="loading" @click="refreshForced">强制刷新缓存</Button>
      </div>
    </div>

    <div class="ding-table-wrap">
      <BaseTable
        :columns="columns"
        :data="pagedData"
        :loading="loading"
        :page="pagination.page"
        :pageSize="pagination.pageSize"
        :count="filteredData.length"
        border
        @on-page-change="(p) => pagination.page = p"
        @on-page-size-change="handlePageSizeChange"
      />
    </div>

    <DingUserDrawer
      v-model="userDrawer.visible"
      :userid="userDrawer.userid"
      :show-edit="true"
      @edit="openEdit"
      @open-dept="openDeptDrawer"
      @open-user="openUserDrawer"
    />
    <DingDeptDrawer
      v-model="deptDrawer.visible"
      :dept-id="deptDrawer.deptId"
      @open-user="openUserDrawer"
      @open-dept="openDeptDrawer"
    />

    <Modal v-model="edit.visible" title="编辑员工" :mask-closable="false">
      <Form :label-width="90" v-if="edit.form">
        <FormItem label="姓名">
          <Input v-model="edit.form.name" />
        </FormItem>
        <FormItem label="职位">
          <Input v-model="edit.form.title" />
        </FormItem>
        <FormItem label="工号">
          <Input v-model="edit.form.job_number" />
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="edit.form.email" />
        </FormItem>
        <FormItem label="分机号">
          <Input v-model="edit.form.telephone" />
        </FormItem>
        <FormItem label="办公地点">
          <Input v-model="edit.form.work_place" />
        </FormItem>
        <FormItem label="直属主管">
          <Input v-model="edit.form.manager_userid" placeholder="manager userid" />
        </FormItem>
        <FormItem label="备注">
          <Input type="textarea" :rows="3" v-model="edit.form.remark" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="edit.visible = false">取消</Button>
        <Button type="primary" :loading="edit.saving" @click="submitEdit">保存</Button>
      </div>
    </Modal>

    <BaseLoadingModal v-model="loading" title="正在加载钉钉人员..." />
  </Container>
</template>

<script>
import Container from '@/components/app/container.vue';
import {
  ensureDingDirectory,
  formatDeptNames,
  getDeptName,
} from './ding-directory';
import DingUserDrawer from './DingUserDrawer.vue';
import DingDeptDrawer from './DingDeptDrawer.vue';

export default {
  name: 'DingUsers',
  components: {Container, DingUserDrawer, DingDeptDrawer},
  data() {
    return {
      loading: false,
      items: [],
      dirTick: 0,
      filter: {
        search: '',
        deptId: '',
      },
      pagination: {
        page: 1,
        pageSize: 20,
      },
      userDrawer: {
        visible: false,
        userid: '',
      },
      deptDrawer: {
        visible: false,
        deptId: '',
      },
      edit: {
        visible: false,
        saving: false,
        userid: '',
        form: null,
      },
    };
  },
  computed: {
    filteredData() {
      void this.dirTick;
      const q = (this.filter.search || '').trim().toLowerCase();
      if (!q) return this.items;
      return this.items.filter((u) => {
        const name = String(u.name || '').toLowerCase();
        const userid = String(u.userid || '').toLowerCase();
        const job = String(u.job_number || '').toLowerCase();
        const mobile = String(u.mobile || '').toLowerCase();
        const depts = formatDeptNames(u.dept_id_list).toLowerCase();
        return name.includes(q)
          || userid.includes(q)
          || job.includes(q)
          || mobile.includes(q)
          || depts.includes(q);
      });
    },
    pagedData() {
      const start = (this.pagination.page - 1) * this.pagination.pageSize;
      return this.filteredData.slice(start, start + this.pagination.pageSize);
    },
    columns() {
      void this.dirTick;
      return [{
        type: 'index',
        width: 60,
      }, {
        title: '姓名',
        key: 'name',
        minWidth: 120,
        render: (h, {row}) => h('a', {
          style: {color: 'var(--primary)', cursor: 'pointer'},
          on: {click: () => this.openUserDrawer(row.userid)},
        }, row.name || '-'),
      }, {
        title: 'userid',
        key: 'userid',
        minWidth: 140,
      }, {
        title: '手机号',
        key: 'mobile',
        width: 130,
      }, {
        title: '职位',
        key: 'title',
        minWidth: 120,
      }, {
        title: '工号',
        key: 'job_number',
        width: 100,
      }, {
        title: '部门',
        key: 'dept_id_list',
        minWidth: 200,
        render: (h, {row}) => this.renderDeptLinks(h, row.dept_id_list),
      }, {
        title: '操作',
        width: 160,
        fixed: 'right',
        render: (h, {row}) => h('div', {class: 'flex-wrap flex-center split5'}, [
          h('Button', {
            props: {size: 'small', type: 'primary'},
            on: {click: () => this.openUserDrawer(row.userid)},
          }, '详情'),
          h('Button', {
            props: {size: 'small'},
            on: {click: () => this.openEdit(row)},
          }, '编辑'),
        ]),
      }];
    },
  },
  mounted() {
    this.$api.afterLogin(() => this.loadData());
  },
  methods: {
    unwrap(res) {
      return (res && res.data && res.data.data) || (res && res.data) || {};
    },
    renderDeptLinks(h, list) {
      const ids = Array.isArray(list) ? list : (list != null && list !== '' ? [list] : []);
      if (!ids.length) return h('span', '-');
      const nodes = [];
      ids.forEach((id, idx) => {
        if (idx) nodes.push(h('span', {style: {color: 'var(--text2)'}}, '、'));
        nodes.push(h('a', {
          style: {color: 'var(--primary)', cursor: 'pointer'},
          on: {
            click: (e) => {
              e.stopPropagation();
              this.openDeptDrawer(id);
            },
          },
        }, getDeptName(id) || String(id)));
      });
      return h('span', nodes);
    },
    openUserDrawer(userid) {
      if (userid == null || userid === '') return;
      this.userDrawer.userid = String(userid);
      this.userDrawer.visible = true;
    },
    openDeptDrawer(deptId) {
      if (deptId == null || deptId === '') return;
      this.deptDrawer.deptId = deptId;
      this.deptDrawer.visible = true;
    },
    handlePageSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
    },
    async loadData(forced = false) {
      this.loading = true;
      try {
        await ensureDingDirectory(this.$api, {forced});
        this.dirTick += 1;
        const params = [];
        if (this.filter.deptId) params.push(`deptId=${encodeURIComponent(this.filter.deptId)}`);
        if (forced) params.push('forced=1');
        const qs = params.length ? `?${params.join('&')}` : '';
        const res = await this.$api.get(`/ding/users${qs}`);
        const data = this.unwrap(res);
        const raw = Array.isArray(data.list) ? data.list : (Array.isArray(data) ? data : []);
        this.items = raw.map((u) => {
          if (u && u.name) return u;
          if (u && Array.isArray(u.field_data_list)) {
            const fields = {};
            u.field_data_list.forEach((f) => {
              if (f && f.field_code) fields[f.field_code] = f.field_value_list;
            });
            const pick = (code) => {
              const arr = fields[code];
              if (!arr || !arr[0]) return '';
              return arr[0].label || arr[0].value || '';
            };
            return Object.assign({}, u, {
              name: u.name || pick('sys00-name'),
              mobile: u.mobile || pick('sys00-mobile'),
              title: u.title || pick('sys00-position'),
            });
          }
          return u;
        });
        this.pagination.page = 1;
      } catch (e) {
        this.Error(e);
      } finally {
        this.loading = false;
      }
    },
    refreshForced() {
      this.loadData(true);
    },
    openEdit(row) {
      const src = row || {};
      this.edit.userid = src.userid;
      this.edit.form = {
        name: src.name || '',
        title: src.title || '',
        job_number: src.job_number || '',
        email: src.email || '',
        telephone: src.telephone || '',
        work_place: src.work_place || '',
        manager_userid: src.manager_userid || '',
        remark: src.remark || '',
      };
      this.edit.visible = true;
    },
    async submitEdit() {
      if (!this.edit.userid || !this.edit.form) return;
      this.edit.saving = true;
      try {
        await this.$api.patch(`/ding/users/${encodeURIComponent(this.edit.userid)}`, this.edit.form);
        this.Success({title: '更新成功'});
        this.edit.visible = false;
        await this.loadData();
      } catch (e) {
        this.Error(e);
      } finally {
        this.edit.saving = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ding-toolbar {
  flex-shrink: 0;
  box-sizing: border-box;
  min-height: 50px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  background: var(--bg);
}
.ding-toolbar-left,
.ding-toolbar-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.ding-muted {
  color: var(--text2);
  font-size: 12px;
}
.ding-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  overflow: hidden;
  position: relative;
}
</style>
